/**
 * CelebrationSection Component
 *
 * Renders the motivational footer of the First Sale Tracker page.
 * Before completion: muted trophy with teaser text and dimmed performance stat.
 * After completion: full-color trophy, congratulations, and prominent stat.
 *
 * The performance stat ("Only X% of agents...") is only displayed when
 * the value falls between 1-99% inclusive. Edge cases (0%, 100%, null)
 * fall back to a fixed congratulatory message.
 */

import React from 'react'
import { observer } from 'mobx-react-lite'
import { MDBCard, MDBCardBody, MDBIcon } from 'mdb-react-ui-kit'
import Store from '../../FirstSaleTracker.store'

import './CelebrationSection.scss'

const CelebrationSection = () => {
  const { isComplete, stats, loading } = Store
  const pct = stats?.pct_first_week
  const showPct = pct !== null && pct > 0 && pct < 100

  return (
    <MDBCard className={`celebration-section ${isComplete ? 'celebration-section--complete' : ''}`}>
      <MDBCardBody className='text-center py-4'>
        {/* Trophy visual */}
        <div className='celebration-section__trophy'>
          <MDBIcon icon='trophy' size='3x' />
        </div>

        {/* Message */}
        <div className='celebration-section__message'>
          {isComplete ? (
            <>
              <h4 className='mb-2'>Congratulations!</h4>
              <p>You've completed your First Sale journey. Keep the momentum going!</p>
            </>
          ) : (
            <>
              <h5 className='mb-2'>Your achievement awaits</h5>
              <p>Complete all 8 milestones to unlock your achievement!</p>
            </>
          )}
        </div>

        {/* Performance stat */}
        <div className='celebration-section__stat'>
          {loading ? (
            <span className='text-muted'>Calculating your achievement...</span>
          ) : showPct ? (
            <span>
              Only <strong>{pct}%</strong> of agents complete these milestones in their first week after completing
              onboarding.
            </span>
          ) : isComplete ? (
            <span>You did it — your first sale is just the beginning.</span>
          ) : null}
        </div>
      </MDBCardBody>
    </MDBCard>
  )
}

export default observer(CelebrationSection)
